<template>      	
    <div class="upper_register">            	     	    	    	    	
    	<div v-if="topLoginLink.includes($route.path)" >
			<p>Already have an account?</p>
	        <router-link :to="'/prism'" >
	        	<img src="../../../../../static/prism_admin/images/register_icon.png" /> Login 
	        </router-link>        
	    </div>     	
    	<div v-else >
	        <p>Dont have an account?</p>        
	        <router-link :to="'/prism/register'">
	        	<img src="../../../../../static/prism_admin/images/register_icon.png" /> Register Here 
	        </router-link>
	    </div>      

        <div v-if="pageLoader" class="loader-info login-loader-info">
            <img src="../../../../../static/prism_admin/images/prism_loader.gif" />
        </div>
    </div>
</template>
<script>   
export default {    
    name : "Login-Header",
    data() {
        return {  
            topLoginLink : [
                '/prism/register',                
                '/prism/register/',                
                '/prism/forgot-password',
                '/prism/reset-password'
            ]    
        }
    },
    props: ['pageLoader']
  }
</script>


// WEBPACK FOOTER //
// src/components/prism_admin/shared/login/login_header.vue